document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".rouge-header");
    // ROUGE 2026-09-14: ヘッダーが無いページでも止まらないようにする。
    // この処理はスクロールのたびに動くため、header が null だと
    // 下の header.offsetHeight でエラーになり、スクロール中ずっと出続ける。
    if (!header) return;
    // ここでヘッダーの高さを取得する
    const headerHeight = header.offsetHeight;
    const scrollY = window.pageYOffset;

    if (scrollY >= 100) {
      // 100pxスクロール後にheader-fixedを付与する
      header.classList.add("rouge-header-fixed");
      // ヘッダーと同じ高さ分の余白をbodyに設置
      document.body.style.marginTop = headerHeight + "px";
    } else {
      header.classList.remove("rouge-header-fixed");
      // 先ほど入れた余白をリセットする
      document.body.style.marginTop = "0";
    }
  });

  const overlay = document.querySelector(".common-modal-overlay");
  const body = document.body;

  // メガメニュー開閉処理
  document
    .querySelectorAll(".rouge-header__list.has-megamenu")
    .forEach((item, index) => {
      const trigger = item.querySelector("a");
      const megamenu = document.querySelectorAll(".rouge__magamenu")[index];

      // ROUGE 2026-09-14: リンクが無いメニュー項目でも止まらないようにする
      if (!trigger) return;

      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        const isOpen = item.classList.contains("is-open");

        // 全部閉じる
        document
          .querySelectorAll(".rouge-header__list.has-megamenu")
          .forEach((el) => el.classList.remove("is-open"));
        document
          .querySelectorAll(".rouge__magamenu")
          .forEach((mm) => mm.classList.remove("is-open"));

        if (!isOpen) {
          // 自分を開く
          item.classList.add("is-open");
          if (megamenu) megamenu.classList.add("is-open");

          // オーバーレイ表示＋スクロール禁止
          overlay?.classList.add("is-active");
          body.classList.add("no_scroll");
        } else {
          // 既に開いてた → 閉じたのでオーバーレイも非表示に
          overlay?.classList.remove("is-active");
          body.classList.remove("no_scroll");
        }
      });
    });

  // 閉じるボタン処理
  // ROUGE 2026-09-22（工程1・B-1）: セレクタを id から class に変更した。
  // 出力元がメニュー項目のループ内にあるため id が必ず重複していた（実測3個）。
  // もともと querySelectorAll で全件を拾っていたので、挙動は変わらない。
  document.querySelectorAll(".rouge-close-btn-wrap").forEach((btn) => {
    btn.addEventListener("click", () => {
      const megamenu = btn.closest(".rouge__magamenu");
      if (megamenu) megamenu.classList.remove("is-open");

      document
        .querySelectorAll(".rouge-header__list.has-megamenu.is-open")
        .forEach((el) => el.classList.remove("is-open"));

      overlay?.classList.remove("is-active");
      body.classList.remove("no_scroll");
    });
  });

  // オーバーレイクリックでメガメニュー全閉
  if (overlay) {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        document
          .querySelectorAll(".rouge__magamenu")
          .forEach((mm) => mm.classList.remove("is-open"));
        document
          .querySelectorAll(".rouge-header__list.has-megamenu.is-open")
          .forEach((el) => el.classList.remove("is-open"));

        overlay.classList.remove("is-active");
        body.classList.remove("no_scroll");
      }
    });
  }
});

/*ハンバーガーメニュー
 ***************************************************************/
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".openbtn");
  const spMenu = document.querySelector(".sp-menu");
  const menuItems = document.querySelectorAll(".sp-menu-list-item");
  const rougeAnnouncement = document.querySelector(".rouge-announcement");
  const rougeHeader = document.querySelector("#rouge-header");
  const body = document.body;
  // 非表示要素は高さ0とみなす
  function getVisibleHeight(element) {
    if (!element) return 0;
    const style = window.getComputedStyle(element);
    return style.display !== "none" ? element.offsetHeight : 0;
  }
  // spMenuのtopを更新
  function updateSpMenuTop() {
    // ROUGE 2026-09-14: .sp-menu が無いページでも止まらないようにする。
    // ここが「Cannot read properties of null (reading 'style')」の発生箇所。
    // この関数は読み込み時・メニュー開閉時・リサイズ時に呼ばれるため、
    // 1度エラーになると、そのあとの処理がすべて止まる。
    if (!spMenu) return;

    /* ROUGE 2026-09-14: メニューの上端の決め方を変更した。

       変更前
         アナウンスバーの高さ ＋ ヘッダーの高さ を足して top に入れていた。
         これはページ上部では正しいが、スクロールしてヘッダーが固定表示に
         なるとアナウンスバーは画面外へ出るため、実際の位置と合わなくなる。
         さらにCSS側が top:60px !important で固定値に上書きしていたため、
         実測でヘッダー下との間に 7px の空白ができていた。

       変更後
         ヘッダーの「画面上での下端」をそのまま使う。
         ページ上部なら 85px（アナウンス＋ヘッダー）、
         固定表示なら 53px（ヘッダーのみ）が自動的に入るので、
         スクロール位置・画面幅・アナウンスバーの有無に関係なく一致する。

       高さ（height）はCSS側で「画面の高さ − この値」にしている。 */
    let menuTop = 0;

    if (rougeHeader) {
      const rect = rougeHeader.getBoundingClientRect();
      // 画面外に出ているときに負の値を入れないよう 0 で止める
      menuTop = Math.max(0, Math.round(rect.bottom));
    } else {
      // ヘッダーが取得できない場合は、従来どおりの足し算で求める
      menuTop = getVisibleHeight(rougeAnnouncement) + getVisibleHeight(rougeHeader);
    }

    spMenu.style.setProperty("--rouge-spmenu-top", menuTop + "px");
  }
  // メニュー開閉
  // ROUGE 2026-09-14: ボタンとメニューが揃っているときだけ登録する
  if (openBtn && spMenu) {
    openBtn.addEventListener("click", function () {
      this.classList.toggle("active");
      spMenu.classList.toggle("show");

      const isOpen = spMenu.classList.contains("show");

      // ROUGE 2026-09-22（工程1・A-11）: 開閉状態を支援技術にも伝える。
      // ボタンは <button> なので Enter / Space はブラウザが click に
      // 変換してくれる。ここでは状態の読み上げだけを担当する。
      this.setAttribute("aria-expanded", isOpen ? "true" : "false");
      this.setAttribute("aria-label", isOpen ? "メニューを閉じる" : "メニューを開く");

      if (isOpen) {
        body.classList.add("no_scroll");
        updateSpMenuTop(); // ← 開いたタイミングでtop再計算
      } else {
        body.classList.remove("no_scroll");
      }
    });
  }
  // メニュー内リンククリック時に閉じる
  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      // ROUGE 2026-09-14: 片方が無いページでも止まらないようにする
      if (openBtn) {
        openBtn.classList.remove("active");
        // ROUGE 2026-09-22（工程1・A-11）: 閉じたことを支援技術にも伝える。
        openBtn.setAttribute("aria-expanded", "false");
        openBtn.setAttribute("aria-label", "メニューを開く");
      }
      if (spMenu) spMenu.classList.remove("show");
      body.classList.remove("no_scroll");
    });
  });

  // スクロールでヘッダー固定
  window.addEventListener("scroll", function () {
    const scrollY = window.pageYOffset;
    const headerHeight = getVisibleHeight(rougeHeader);
    const spMenuOnScroll = document.querySelector(".sp-menu");

    // ROUGE 2026-09-14: ヘッダーが無いページでも止まらないようにする。
    // この処理はスクロールのたびに動くため、対策しないとエラーが出続ける。
    if (rougeHeader) {
      if (scrollY >= 100) {
        rougeHeader.classList.add("rouge-header-fixed");
        document.body.style.marginTop = headerHeight + "px";
      } else {
        rougeHeader.classList.remove("rouge-header-fixed");
        document.body.style.marginTop = "0";
      }
    }

    // メニュー開いてるときは .sp-menu の上端を再設定
    // ROUGE 2026-09-14: ここも .sp-menu が無いと null.style になる。
    // あわせて、上の updateSpMenuTop() と同じ決め方（ヘッダーの実際の下端）に
    // そろえた。以前はここだけ headerHeight を直接入れていたため、
    // アナウンスバーが見えている状態と計算が食い違っていた。
    if (spMenuOnScroll && spMenuOnScroll.classList.contains("show")) {
      updateSpMenuTop();
    }
  });

  // ウィンドウリサイズ対応
  window.addEventListener("resize", function () {
    // ROUGE 2026-09-14: .sp-menu が無いページでも止まらないようにする
    if (spMenu && spMenu.classList.contains("show")) {
      updateSpMenuTop();
    }
  });
  // 初期化
  updateSpMenuTop();
});

// document.addEventListener("DOMContentLoaded", function () {
//   const openBtn = document.querySelector(".openbtn");
//   const spMenu = document.querySelector(".sp-menu");
//   const menuItems = document.querySelectorAll(".sp-menu-list-item");
//   const rougeAnnouncement = document.querySelector(".rouge-announcement");
//   const rougeHeader = document.querySelector("#rouge-header");
//   const body = document.body; // ★ここ追加！

//   openBtn.addEventListener("click", function () {
//     this.classList.toggle("active");
//     spMenu.classList.toggle("show");

//     // ★ sp-menuが開いてたらno_scrollを付与、閉じたら外す
//     if (spMenu.classList.contains("show")) {
//       body.classList.add("no_scroll");
//     } else {
//       body.classList.remove("no_scroll");
//     }
//   });

//   menuItems.forEach((item) => {
//     item.addEventListener("click", function () {
//       openBtn.classList.remove("active");
//       spMenu.classList.remove("show");
//       body.classList.remove("no_scroll"); // ★メニュー項目クリックでも解除
//     });
//   });

//   // .rouge-announcement と #rouge-header の高さを取得して合計
//   const announcementHeight = rougeAnnouncement
//     ? rougeAnnouncement.offsetHeight
//     : 0;
//   const headerHeight = rougeHeader ? rougeHeader.offsetHeight : 0;
//   const totalHeight = announcementHeight + headerHeight;

//   // .sp-menu の top を設定
//   spMenu.style.top = `${totalHeight}px`;
// });

/* ハンバーガーメニュー内のアコーディオン
 ***************************************************************/
document.addEventListener("DOMContentLoaded", function () {
  const accordionToggles = document.querySelectorAll(".has-accordion");

  accordionToggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault(); // リンク動作無効（必要なら）

      const accordion = toggle.nextElementSibling; // .rouge__accordionを取得

      if (accordion && accordion.classList.contains("rouge__accordion")) {
        accordion.classList.toggle("is-open");
        toggle.classList.toggle("open"); // ← .has-accordionにも.openクラスを付与
      }
    });
  });
});

/* 検索モーダル
 ***************************************************************/
document.addEventListener("DOMContentLoaded", function () {
  const openButton = document.getElementById("rouge-search");
  const searchModal = document.getElementById("rouge-search-modal");
  const overlay = document.querySelector(".common-modal-overlay");
  const body = document.body;
  const closeButton = document.getElementById("rouge-search-close-btn"); // ★追加！

  // ROUGE 2026-09-22（工程1・C-6）: 要素が無いページでも止まらないようにする。
  //
  // 以前は openButton / overlay / closeButton を取得後、いきなり
  // addEventListener を呼んでいた。いずれか1つでも存在しないページでは
  // そこで例外になり、この DOMContentLoaded 内の以降の処理
  // （下にある商品アコーディオン）がまとめて動かなくなる状態だった。
  //
  // ここで return してしまうと同じ問題を作ることになるため、
  // 早期終了はせず、要素ごとに個別に確認してから登録する。

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add("is-active");
    if (overlay) overlay.classList.add("is-active");
    body.classList.add("no_scroll");
  }

  function closeSearch() {
    if (searchModal) searchModal.classList.remove("is-active");
    if (overlay) overlay.classList.remove("is-active");
    body.classList.remove("no_scroll");
  }

  if (openButton && searchModal) {
    openButton.addEventListener("click", openSearch);

    // ROUGE 2026-09-22（工程1）: 検索アイコンは <div> に
    // role="button" tabindex="0" を付けた作りだが、キーボードの
    // Enter / Space を受け取る処理が無く、フォーカスできても開けなかった。
    // <button> ではないので、ここで標準と同じ挙動を補う。
    openButton.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") return;
      event.preventDefault();
      openSearch();
    });
  }

  if (overlay) overlay.addEventListener("click", closeSearch);

  // ★閉じるボタン押したときの処理
  if (closeButton) closeButton.addEventListener("click", closeSearch);

  // 商品詳細ページアコーディオン
  const items = document.querySelectorAll(".rouge-product__accordion-item");

  items.forEach((item) => {
    const title = item.querySelector(".rouge-product__accordion-title");
    const content = item.querySelector(".rouge-product__accordion-text");

    // ROUGE 2026-09-22（工程1・C-6）: 見出しか本文が欠けている項目でも止めない。
    // 以前は title が null のまま addEventListener を呼んでいたため、
    // 1項目でも構造が違うとこの forEach ごと例外で止まり、
    // それ以降のアコーディオンがすべて開かなくなっていた。
    if (!title || !content) return;

    title.addEventListener("click", () => {
      content.classList.toggle("is-open");
      item.classList.toggle("open");
    });
  });

  // 商品詳細ページタブ
  // const tabs = document.querySelectorAll(".js-tab");
  // const contents = document.querySelectorAll(".js-content");

  // tabs.forEach((tab, index) => {
  //   tab.addEventListener("click", function () {
  //     // タブのcurrentクラスを切り替え
  //     tabs.forEach((t) => t.classList.remove("current"));
  //     this.classList.add("current");

  //     // コンテンツの表示切り替え
  //     contents.forEach((c) => (c.style.display = "none"));
  //     contents[index].style.display = "block";
  //   });
  // });

  // // 初期表示：最初のタブ以外を非表示に
  // contents.forEach((c, i) => {
  //   c.style.display = i === 0 ? "block" : "none";
  // });
});

// ROUGE: カートドロワー/モーダル表示中は、右下のチャット吹き出し等の追従ウィジェットを隠す
// （購入手続きボタンとの重なり防止。閉じれば自動で元に戻る。該当要素が無ければ何もしない）
;(function () {
  var CHAT_SEL = [
    // ROUGE 2026-09-22（工程2）: 素のタグ名を追加した。
    // Shopify Inbox が置くのは <shopify-chat> という要素で、
    // id もクラスも付かない。下の '#shopify-chat' や '[class*=...]' では
    // 1件も当たっておらず、このJSは実質なにも隠せていなかった。
    // （カートドロワー表示中はCSS側で隠せていたため表面化していなかった）
    'shopify-chat',
    '#shopify-chat',
    '[id*="shopify-chat"]',
    '[class*="shopify-chat"]',
    '[id*="inbox-chat"]',
    '[class*="inbox-chat"]',
    'iframe[src*="shopify-chat"]',
    'iframe[src*="shopifychat"]',
    'iframe[title*="チャット"]',
    'iframe[title*="chat" i]'
  ].join(',');

  // 購入導線は絶対に触らない（カート/チェックアウト内の要素は保護）
  var PROTECT_SEL = 'cart-drawer, #CartDrawer, cart-notification, form[action*="/cart"], [name="checkout"], [class*="checkout"], [class*="cart__"]';

  function toggleWidgets(hide) {
    try {
      document.querySelectorAll(CHAT_SEL).forEach(function (el) {
        if (el.closest(PROTECT_SEL)) return; // カートドロワー内などは隠さない
        el.style.setProperty('visibility', hide ? 'hidden' : '', 'important');
        el.style.setProperty('pointer-events', hide ? 'none' : '', 'important');
      });
    } catch (e) {}
  }

  function check() {
    toggleWidgets(document.body.classList.contains('overflow-hidden'));
  }

  document.addEventListener('DOMContentLoaded', function () {
    check();
    new MutationObserver(check).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
})();
